import { jsx as _jsx } from "react/jsx-runtime";
import { captureException } from '@sentry/react';
import { Component, } from 'react';
export class ErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console -- Logging here will add additional Breadcrumbs to the Sentry event
        console.error('ErrorBoundary caught:', error, info.componentStack);
        captureException(error, {
            contexts: {
                react: {
                    componentStack: info.componentStack,
                },
            },
            tags: {
                'error-boundary': this.props.name ?? 'unnamed',
            },
        });
    }
    resetErrorBoundary = () => {
        this.props.onReset?.();
        this.setState({ error: null });
    };
    render() {
        if (this.state.error) {
            // 1. Rethrowable errors —  always re-throw
            if (this.props.rethrow?.some(
            // eslint-disable-next-line @typescript-eslint/naming-convention -- Error classes
            (ErrorType) => this.state.error instanceof ErrorType)) {
                throw this.state.error;
            }
            // 2. Handlers —  match specific error to specific fallback
            const handlerToRender = this.props.handlers?.find((handler) => this.state.error instanceof handler.errorClass);
            if (handlerToRender) {
                return (_jsx(handlerToRender.Component, { error: this.state.error, reset: this.resetErrorBoundary }));
            }
            // 3. Default fallback —  catch-all
            if (this.props.DefaultFallback) {
                return (_jsx(this.props.DefaultFallback, { error: this.state.error, reset: this.resetErrorBoundary }));
            }
            // 4. Nothing matched, no default —  re-throw
            throw this.state.error;
        }
        return this.props.children;
    }
}
